module.exports = __webpack_public_path__ + "static/media/rightarrCircle.0cca71b2.svg";